import { type ElementType, type ReactNode } from 'react'

import { typography, type TypographyVariant } from './variants'

type TextVariant = 'body' | 'bodyLg' | 'bodySm' | 'bodyInverse' | 'caption'

export interface TextProps {
  as?: ElementType
  variant?: TextVariant
  children: ReactNode
  className?: string
  /** Optional alignment – e.g. text-left, text-justify */
  align?: string
}

const variantToDefaultTag: Record<TextVariant, ElementType> = {
  body: 'p',
  bodyLg: 'p',
  bodySm: 'p',
  bodyInverse: 'p',
  caption: 'p',
}

export function Text({ as, variant = 'body', children, className = '', align }: TextProps) {
  const Tag = as ?? variantToDefaultTag[variant]
  const baseClasses = typography[variant as TypographyVariant]
  const classes = [baseClasses, align, className].filter(Boolean).join(' ')
  return <Tag className={classes}>{children}</Tag>
}
